var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect, useHistory, } from "@discovery/common-dplus/lib/hooks";
import { clientInformation } from "@discovery/common-dplus/lib/device-info";
import { envBrowser } from "@discovery/maestro-env-browser";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config, _isParentalLockAccess, _IsUserPremiumFromPartners, _showAllAccessPopUp, } from "@discovery/common-dplus/lib/state";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import { compose } from "@discovery/prelude/lib/data/function";
import * as CQ from "@discovery/sonic-api-ng/lib/api/common/query";
import * as RecentSearch from "@discovery/sonic-api-ng/lib/api/users/custom-attributes";
import * as User from "@discovery/sonic-api-ng/lib/api/users/me";
import * as Profile from "@discovery/sonic-api-ng/lib/api/users/profiles";
import { navigateTo } from "../../utils/common";
import { _emptyResonpnse } from "../optics";
import { _CustomAttribute2Attributes } from "../optics";
import { _UserProfiles, _Partner, _PartnerName, _SubscriptionType, _PaymentProvider, _SubscriptionStatus, _EmandateInfo, } from "./optics";
import * as E from "fp-ts/Either";
import * as App from "@discovery/maestro";
import Drawer from "../../components/organisms/drawer";
import ScriptCache from "../../utils/scriptcache/scriptcache";
import dplusgtagmanager from "../../utils/scriptcache/dplustagmanager";
import dplusbranchio from "../../utils/scriptcache/dplusbranchio";
import { provideAdobeUrl } from "@discovery/common-dplus/lib/bus";
import { adobeUrlStaging, adobeUrlProd } from "@discovery/common-dplus/lib/env";
import { BRANCH_KEY_DEV, BRANCH_KEY_PROD, } from "@discovery/common-dplus/lib/env";
import { useUser } from "../../utils/hooks";
import * as Partners from "@discovery/sonic-api-ng/lib/api/users/partners";
import * as Emandate from "@discovery/sonic-api-ng/lib/api/monetization/subscriptions/emandate";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
import { PartnerBanner } from "../../components/molecules/partner-banner";
import * as Subscription from "@discovery/sonic-api-ng/lib/api/monetization/subscriptions";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import PaymentUpdateModal from "../../components/molecules/payment-update-modal";
import { setAuthRedirectUrl } from "../../utils/authUrl";
import { blueshiftAuthentication, blueshiftEnvironmentData, initializeBlueshift, } from "../../../../common/src/blueshift";
const AllAccess = React.lazy(() => import("../../components/molecules/parental-lock/firstFlowModals/allAccess"));
export const DrawerView = ({ headerData, hamburgerList, hamburgerFooterList, read, webAuthRedirectionUrl, userM, environment, }) => {
    const [showAllAccess] = useGlobalState(_isParentalLockAccess);
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const [showPopUp] = useGlobalState(_showAllAccessPopUp);
    const { isPremiumUser, isAnonymous } = useUser();
    const [changes] = useHistory();
    const updateGlobalShowPopUp = updateGlobalState(_showAllAccessPopUp);
    const [showAllAccessAfterTimeLock, setShowAllAccessAfterTimeLock] = useState(false);
    const [defaultProfileId, setDefaultProfileId] = useState("");
    const [profilePicUrl, setProfilePicUrl] = useState("");
    const [visibility, setVisibility] = useState(0);
    const [userProfileLength, setUserProfileLength] = useState(0);
    const [showPartnerBanner, setShowPartnerBanner] = useState(false);
    const [subscriptionType, setSubscriptionType] = useState("");
    const [showPaymentUpdateModal, setShowPaymentUpdateModal] = useState(false);
    const [isEmandate, setEmandate] = useState(false);
    const isUserPremium = isPremiumUser || isPremiumUserFromPartner;
    const userDetailsM = M.map((user) => ({
        id: user.id,
        loggedIn: user.attributes.anonymous,
        packagesM: user.attributes.packages,
        firstNameM: user.attributes.firstName,
        lastNameM: user.attributes.lastName,
        location: user.attributes.currentLocationTerritory,
        realm: user.attributes.realm,
        userPhoneNumberM: user.attributes.validatedPhoneNumber,
        userEmailIdM: user.attributes.username,
    }), userM);
    const userId = M.fromMaybe(M.map((user) => user.id, userDetailsM), "");
    const loggedIn = M.fromMaybe(M.map((user) => user.loggedIn, userDetailsM), false);
    const firstName = M.fromMaybe(M.chain((user) => user.firstNameM, userDetailsM), "");
    const lastName = M.fromMaybe(M.chain((user) => user.lastNameM, userDetailsM), "");
    const userPhoneNumber = M.fromMaybe(M.chain((user) => user.userPhoneNumberM, userDetailsM), "");
    const userEmailId = M.fromMaybe(M.chain((user) => user.userEmailIdM, userDetailsM), "");
    const realm = M.fromMaybe(M.map((user) => user.realm, userDetailsM), "");
    const currentLocation = M.fromMaybe(M.map((user) => user.location, userDetailsM), "");
    useEffect(() => {
        initializeBlueshift(userId, firstName, lastName, userPhoneNumber, userEmailId);
        blueshiftAuthentication(userId, loggedIn);
        blueshiftEnvironmentData(loggedIn, currentLocation, realm);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [configM] = useGlobalState(_Config);
    const intervalBetweenMessagesInDaysM = M.chain((x) => x.affiliateMessaging, configM);
    const intervalBetweenMessagesInDaysForPartnerBannerM = M.chain((x) => x.intervalBetweenMessagesInDays, intervalBetweenMessagesInDaysM);
    const intervalBetweenMessagesInDaysForPartnerBanner = M.fromMaybe(intervalBetweenMessagesInDaysForPartnerBannerM, 0);
    const displayForPartnerWithNamesConfig = M.chain((x) => x.affiliateMessaging, configM);
    const displayForPartnerWithNamesM = M.chain((x) => x.displayForPartnerWithNames, displayForPartnerWithNamesConfig);
    const displayForPartnerWithNames = M.fromMaybe(displayForPartnerWithNamesM, [
        "",
    ]);
    const featureTogglesM = M.chain((x) => x.featureToggles, configM);
    const emandateEnabledM = M.chain((x) => x.emandateEnabled, featureTogglesM);
    const eMandateDialogM = M.chain((x) => x.eMandateDialog, configM);
    const eMandateDialog = M.fromMaybe(eMandateDialogM, {});
    const emandateEnabled = M.fromMaybe(emandateEnabledM, false);
    const webAuthUrl = read.authService.protocol + "://" + read.authService.domain;
    const authUrl = webAuthUrl + config.authenticationURLs.updatePaymentMethod;
    const setShowAllAccess = (accessState) => updateGlobalState(Lens.prop("isParentalLockAccess"))((_isParentalLockAccess) => accessState);
    const userProfiles = () => __awaiter(void 0, void 0, void 0, function* () {
        const endpoint = Profile.Endpoints.getProfiles();
        yield App.run(endpoint)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const userProfilesM = Fold.preview(_UserProfiles, response);
            const userProfiles = M.fromMaybe(userProfilesM, []);
            const defaultProfile = userProfiles.filter((item) => M.fromMaybe(item.attributes.ageRestricted, false) ===
                true);
            const defaultProfileId = defaultProfile && defaultProfile[0] && defaultProfile[0].id; //since there will be only one default profile
            sessionStorage.setItem("profLen", userProfiles.length.toString());
            defaultProfileId && setDefaultProfileId(defaultProfileId);
            updateGlobalState(Lens.prop("userProfilesLength"))((_userProfilesLength) => userProfiles.length);
            setUserProfileLength(userProfiles.length);
        }));
    });
    const switchUserProfile = (selectedProfileId) => {
        if (userId && selectedProfileId) {
            const postRequest = User.Endpoints.patchMe(userId, selectedProfileId);
            App.run(postRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
                /* handle exception here */
            }, () => {
                sessionStorage.removeItem("pA");
                sessionStorage.removeItem("timeLockVisibility");
                localStorage.removeItem("isAllAccess");
                localStorage.removeItem("isSuccessPa");
                // TODO - temporary fix as we do not have sonic support yet to handle this
                // when in all-access page, show page and video player page turning on to kids safe mode
                // navigate to home page else reload the same page
                changes.location.pathname === "/channel/all-access" ||
                    changes.location.pathname.split("/")[1] === "show" ||
                    changes.location.pathname.split("/")[1] === "videos"
                    ? navigateTo(config.standardPageRouteFragments.home)
                    : window.location.reload();
            }));
        }
    };
    const handleOnBackClick = () => {
        switchUserProfile({
            selectedProfileId: defaultProfileId,
        });
        setShowAllAccessAfterTimeLock(false);
        updateGlobalShowPopUp((_old) => false);
    };
    const watchQueryParams = () => {
        setShowAllAccessAfterTimeLock(false);
        updateGlobalShowPopUp((_old) => false);
        handleOnBackClick();
    };
    const checkActiveSessionVisibility = () => {
        if (document.visibilityState === "visible") {
            const getTime = new Date().getMinutes();
            const calculateTime = getTime - visibility;
            if (calculateTime > config.parentalLock.timeoutInMinsForAutolock) {
                window.addEventListener("popstate", watchQueryParams);
                setShowAllAccessAfterTimeLock(true);
                updateGlobalShowPopUp((_old) => true);
            }
            else {
                setShowAllAccessAfterTimeLock(false);
                updateGlobalShowPopUp((_old) => false);
            }
        }
        else {
            const setTime = new Date().getMinutes();
            setVisibility(setTime);
            window.removeEventListener("popstate", watchQueryParams);
        }
    };
    const showPartnerBannerBasedOnPaymentProvider = (subscriptionType, paymentProvider, subscriptionStatus) => {
        const isBannerClicked = localStorage.getItem("isPartnerBannerClicked");
        if (subscriptionType === "IAP") {
            setSubscriptionType(paymentProvider);
            isBannerClicked === null &&
                paymentProvider !== "" &&
                setShowPartnerBanner(true);
            localStorage.setItem("getPartnerBannerPresentationTime", Date());
            localStorage.setItem("PartnerBannerPreviouslyDisplayed", "true");
        }
        else if (subscriptionType === "PAYING") {
            setSubscriptionType(paymentProvider);
            isBannerClicked === null && setShowPartnerBanner(true);
            localStorage.setItem("getPartnerBannerPresentationTime", Date());
            localStorage.setItem("PartnerBannerPreviouslyDisplayed", "true");
        }
        else {
            setSubscriptionType("");
            subscriptionStatus === ""
                ? setShowPartnerBanner(false)
                : isBannerClicked === null && setShowPartnerBanner(true);
            localStorage.setItem("getPartnerBannerPresentationTime", Date());
            localStorage.setItem("PartnerBannerPreviouslyDisplayed", "true");
        }
    };
    const displayPartnerBannerMessage = (subscriptionType, paymentProvider, subscriptionStatus) => {
        const getPartnerBannerPresentationDate = localStorage.getItem("getPartnerBannerPresentationTime");
        const isPartnerBannerPreviouslyDisplayed = localStorage.getItem("PartnerBannerPreviouslyDisplayed");
        const earlierDate = getPartnerBannerPresentationDate &&
            new Date(getPartnerBannerPresentationDate);
        const currentDate = new Date();
        const difference = earlierDate &&
            Math.floor((Date.UTC(earlierDate.getFullYear(), earlierDate.getMonth(), earlierDate.getDate()) -
                Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) /
                (1000 * 60 * 60 * 24));
        if (isPartnerBannerPreviouslyDisplayed === null) {
            showPartnerBannerBasedOnPaymentProvider(subscriptionType, paymentProvider, subscriptionStatus);
        }
        else if (difference &&
            difference > intervalBetweenMessagesInDaysForPartnerBanner) {
            showPartnerBannerBasedOnPaymentProvider(subscriptionType, paymentProvider, subscriptionStatus);
        }
        else {
            setShowPartnerBanner(false);
        }
    };
    const getSubscriptionDetails = (partnerName) => __awaiter(void 0, void 0, void 0, function* () {
        const endpoint = Subscription.Endpoints.getSubscriptions(compose(Subscription.Query.lenses.include.set(CQ.Include.include("paymentMethod")), Subscription.Query.lenses.filters.set(CQ.Filters.filters(CQ.Filter.filterOr("status", "ACTIVE"))))(Subscription.Query.parameters));
        yield App.run(endpoint)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const paymentProviderM = Fold.preview(_PaymentProvider, response);
            const subscriptionStatusM = Fold.preview(_SubscriptionStatus, response);
            const subscriptionStatus = M.fromMaybe(subscriptionStatusM, "");
            const paymentProvider = M.fromMaybe(paymentProviderM, "");
            const subscriptionTypeM = Fold.preview(_SubscriptionType, response);
            const subscriptionType = M.fromMaybe(subscriptionTypeM, "");
            const displayPartnerMessage = displayForPartnerWithNames.includes(partnerName);
            if (displayPartnerMessage) {
                displayPartnerBannerMessage(subscriptionType, paymentProvider, subscriptionStatus);
            }
        }));
    });
    const getPartners = () => {
        let partner = 0;
        const getPartnersRequest = Partners.Endpoints.getPartners();
        App.run(getPartnersRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const partnerM = Fold.preview(_Partner, response);
            partner = M.fromMaybe(partnerM, []);
            const partnerNameM = Fold.preview(_PartnerName, response);
            const partnerName = M.fromMaybe(partnerNameM, "");
            if (partner.length > 0 && displayForPartnerWithNames.length > 0) {
                getSubscriptionDetails(partnerName);
            }
        }));
    };
    const getEmandate = () => {
        const getPartnersRequest = Emandate.Endpoints.getEMandateList();
        App.run(getPartnersRequest)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const emandateM = Fold.preview(_EmandateInfo, response);
            const emandate = M.fromMaybe(emandateM, {});
            const isEmandateRequired = Object.values(emandate).every((itemM) => {
                const item = M.fromMaybe(itemM, false);
                return item === true;
            });
            setShowPaymentUpdateModal(isUserPremium && isEmandateRequired);
        }));
    };
    useEffect(() => {
        const isAllAccess = sessionStorage.getItem("pA");
        userProfiles();
        !isAnonymous && getPartners();
        const selectedProfile = sessionStorage.getItem("selectedProfile");
        if (selectedProfile === "all-access") {
            setShowAllAccess(true);
        }
        else {
            setShowAllAccess(false);
        }
        if (isAllAccess) {
            setShowAllAccess(true);
            window.addEventListener("visibilitychange", checkActiveSessionVisibility);
        }
        else {
            setShowAllAccess(false);
            window.removeEventListener("visibilitychange", checkActiveSessionVisibility);
        }
        const dplusgpt = {
            initialize: "https://securepubads.g.doubleclick.net/tag/js/gpt.js",
            tagType: "src",
        };
        const dplusJquery = {
            initialize: "https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js",
            tagType: "src",
        };
        const gtmScript = dplusgtagmanager.initialize({
            id: "GTM-P5NXL5F",
        });
        const dplusgtmScript = {
            initialize: gtmScript.gtmScript,
            tagType: "innerhtmlhead",
        };
        const dplusgtmNoScript = {
            initialize: gtmScript.gtmNoScript,
            tagType: "innerhtmlNoScript",
        };
        const cache = ScriptCache({
            branchIO: dplusbranchio,
            gpt: dplusgpt,
            jquery: dplusJquery,
            dplusgtmScript: dplusgtmScript,
            dplusgtmNoScript: dplusgtmNoScript,
        });
        let adobeUrl = adobeUrlProd;
        if (environment === "prod") {
            branch.init(BRANCH_KEY_PROD);
            adobeUrl = adobeUrlProd;
        }
        else {
            branch.init(BRANCH_KEY_DEV);
            adobeUrl = adobeUrlStaging;
        }
        provideAdobeUrl(cache, adobeUrl).catch(() => void 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const parentalLockHandler = (id) => {
        if (isAnonymous && id === "allAccess") {
            const authRedirect = setAuthRedirectUrl(window.location.pathname);
            navigateTo(`${webAuthRedirectionUrl + "/login"}?returnUrl=${authRedirect}`);
        }
        else {
            if (id === "allAccess" && !showAllAccess) {
                const url = window.location.href;
                const searchParams = new URLSearchParams(window.location.search);
                searchParams.set("allAccess", "landing");
                const newParams = searchParams.toString();
                const newurl = url.indexOf("?")
                    ? window.location.pathname + `${"?" + newParams}`
                    : window.location.pathname + `${"?" + "allAccess=landing"}`;
                window.history.pushState({ path: newurl }, "", newurl);
                setShowAllAccess(true);
                updateGlobalShowPopUp((_old) => true);
            }
            if (id === "kids" && showAllAccess) {
                setShowAllAccess(false);
                updateGlobalShowPopUp((_old) => false);
                switchUserProfile({
                    selectedProfileId: defaultProfileId,
                });
            }
        }
    };
    const handlePopUpclose = () => {
        updateGlobalShowPopUp((_old) => false);
    };
    const fetchUserProfilePic = () => __awaiter(void 0, void 0, void 0, function* () {
        const endpoint = RecentSearch.Endpoints.getGenericCustomAttributes("profile-pic-URL");
        yield App.run(endpoint)(Object.assign(Object.assign(Object.assign({}, envBrowser), read), { clientInformation: clientInformation })).then(E.fold((_exception) => {
            /* handle exception here */
        }, (response) => {
            const errorCodeM = Fold.preview(_emptyResonpnse, response);
            const errorCode = M.fromMaybe(errorCodeM, "");
            if (errorCode === "404") {
                return;
            }
            else {
                const profilePicUrlM = Fold.preview(_CustomAttribute2Attributes, response);
                const profilePicUrl = M.fromMaybe(profilePicUrlM, "");
                const src = profilePicUrl["profile-pic-URL"];
                setProfilePicUrl(src);
            }
        }));
    });
    const resetToggle = () => {
        updateGlobalShowPopUp((_old) => !showPopUp);
    };
    const dismissPartnerBanner = () => {
        localStorage.setItem("isPartnerBannerClicked", "true");
        setShowPartnerBanner(false);
    };
    const allowAllAccess = () => {
        setShowAllAccess(true);
    };
    const closePayementUpdateModal = () => {
        const lastDate = new Date();
        const publishesDate = lastDate.getTime();
        localStorage.setItem("lastPaymentUpdateMsgDisplayTime", JSON.stringify(publishesDate));
        localStorage.setItem("lastUserID", defaultProfileId);
        setShowPaymentUpdateModal(false);
    };
    useEffect(() => {
        const isAllAccess = sessionStorage.getItem("pA");
        showAllAccess ? setShowAllAccess(true) : setShowAllAccess(false);
        if (isAllAccess) {
            setShowAllAccess(true);
            updateGlobalShowPopUp((_old) => false);
        }
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        const lastUserId = localStorage.getItem("lastUserID");
        const isSameUser = lastUserId === defaultProfileId;
        const lastPaymentUpdateMsgDisplayTime = localStorage.getItem("lastPaymentUpdateMsgDisplayTime");
        const lastPaymentModalShownTime = isSameUser &&
            lastPaymentUpdateMsgDisplayTime &&
            JSON.parse(lastPaymentUpdateMsgDisplayTime);
        const currentDate = new Date();
        const differenceInTime = currentDate.getTime() - lastPaymentModalShownTime;
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
        const showPaymentUpdateModal = differenceInDays > 1;
        setEmandate(showPaymentUpdateModal);
        !isAnonymous && emandateEnabled && showPaymentUpdateModal && getEmandate();
    }, [defaultProfileId]); // eslint-disable-line react-hooks/exhaustive-deps
    return (React.createElement(React.Fragment, null,
        React.createElement(Drawer, { headerData: headerData, hamburgerList: hamburgerList, hamburgerFooterList: hamburgerFooterList, read: read, webAuthRedirectionUrl: webAuthRedirectionUrl, isAllAccess: showAllAccess, allAccessToggle: (id) => parentalLockHandler(id), fetchProfilePic: fetchUserProfilePic, profilePicUrl: profilePicUrl, userM: userM }),
        React.createElement(React.Suspense, { fallback: () => React.createElement("div", null, "Loading...") }, showPopUp && (React.createElement(AllAccess, { route: "landing", toggleAllAccess: resetToggle, read: read, userProfileLength: userProfileLength && userProfileLength, hideAllAccessPopup: handlePopUpclose, allowAllAccess: allowAllAccess, timeOut: true, onBackHandlerAfterTimeLock: handleOnBackClick, timeLockVisibilityEvent: true, showAllAccessAfterTimeLock: showAllAccessAfterTimeLock }))),
        showPartnerBanner && (React.createElement(PartnerBanner, { dismissPartnerBanner: dismissPartnerBanner, subscriptionType: subscriptionType })),
        showPaymentUpdateModal && isEmandate && (React.createElement(PaymentUpdateModal, { closePayementUpdateModal: closePayementUpdateModal, authUrl: authUrl, defaultProfileId: defaultProfileId, eMandateDialog: eMandateDialog }))));
};

